<template>
  <div class="c-gift-card">
    <button
      v-if="isEdit"
      :disabled="isClosed"
      @click="closed"
      class="icon-close"
      type="button"
    >
      <base-icon class="icon" width="20px" height="20px" name="painel/close" />
    </button>
    <div class="wrapper-image">
      <img
        @click="clicked"
        :data-src="image"
        :alt="name"
        class="image lazy-load"
      />
    </div>
    <p @click="clicked" class="name">{{ name }}</p>
    <p @click="clicked" class="price">{{ priceWithCurrency }}</p>
    <p class="quotas">
      <template v-if="requested > 0 || purchased > 0">
        {{ `Solicitado: ${requested} | Comprado: ${purchased}` }}
      </template>
    </p>
    <button v-if="isEdit" @click="clicked" class="button-action" type="button">
      <base-icon
        class="icon"
        width="24px"
        height="24px"
        name="painel/icon-edit-list"
      />
      editar
    </button>
    <button v-else @click="clicked" class="button-action" type="button">
      <base-icon
        class="icon"
        width="24px"
        height="24px"
        name="painel/plus-circle"
      />
      adicionar
    </button>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      require: true,
    },
    requested: {
      type: Number,
      default: 2,
    },
    purchased: {
      type: Number,
      default: 0,
    },
    price: {
      type: String,
      require: true,
    },

    image: {
      type: String,
      require: true,
    },

    isEdit: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    priceWithCurrency() {
      const price = parseFloat(this.price)
      return price.toLocaleString('PT-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL',
      })
    },
  },

  data() {
    return {
      isClosed: false,
    }
  },

  methods: {
    clicked() {
      this.$emit('clicked')
    },

    closed() {
      this.isClosed = true
      this.$emit('closed')

      setTimeout(() => {
        this.isClosed = false
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
.quotas {
  margin: 16px 0px;
  color: #5d758d;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  min-height: 1em;
}

.c-gift-card {
  position: relative;
  display: block;
  flex: none;
  width: 100%;
  padding: 8px;
  border: 1px solid #dde7f1;
  border-radius: 16px;
  text-align: center;
  color: $neutral;
  line-height: 1;
  background-color: $white;
  @media screen and (min-width: 1024px) {
    padding: 16px;
  }

  .icon {
    min-width: 24px;
    min-height: 24px;
  }

  .icon-close {
    @include position(absolute, 6px, 6px, auto, auto);
    display: inline-flex;
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
    color: $white;
    border: 0;
    z-index: 1;
    cursor: pointer;
    border-radius: 8px;
    transition: 0.15s all ease-in-out;
    filter: drop-shadow(0px 2px 4px rgba(93, 117, 141, 0.2));
    background-color: $primary;
    &:hover {
      width: 35px;
      height: 35px;
      border: 0;
    }
    .icon {
      min-width: 20px;
      min-height: 20px;
    }
  }

  .wrapper-image {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 144px;
    max-height: 144px;
    @media screen and (min-width: 1024px) {
      height: 208px;
      max-height: 208px;
    }
  }

  .image {
    display: block;
    width: 100%;
    height: 144px;
    border-radius: 16px;
    object-fit: cover;
    cursor: pointer;
    @media screen and (min-width: 1024px) {
      height: 208px;
    }
  }

  .name {
    display: block;
    display: -webkit-box;
    width: 100%;
    height: 48px;
    margin: 8px 0;
    font-size: 14px;
    line-height: 16px;
    color: $neutral;
    cursor: pointer;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .price {
    margin: 8px 0;
    font-size: 18px;
    font-weight: bold;
    line-height: 20px;
    cursor: pointer;
  }

  .button-action {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
    color: $support;
    border: 0;
    cursor: pointer;
    background-color: transparent;
    &:hover,
    &:focus {
      border: 0;
      color: $supportdark;
    }

    .icon {
      margin-right: 8px;
    }
  }
}
</style>
